export default "__VITE_ASSET__f215e6dc__"